import { createSelector } from 'reselect'
import resources from '../../api/resources';
import { getArrayOfObjectValues } from '../../utils';

export const getMixingPlantsSelector = createSelector(
  mixingPlant => mixingPlant.mixingPlant,
  (mixingPlantsById) => getArrayOfObjectValues(mixingPlantsById, resources.MixingPlants)
);